/**
 * Flavorstone · componentes custom del tema.
 */

/**
 * Ajusta el tamaño de todos los títulos de las cards al mismo valor,
 * el más grande con el que el nombre más largo cabe en un solo renglón.
 */
class FsCategories extends HTMLElement {
  /** Tamaño mínimo en px; por debajo de esto se permite partir en renglones. */
  static MIN_SIZE = 18;

  connectedCallback() {
    this.fit = this.fit.bind(this);
    this.resizeObserver = new ResizeObserver(this.fit);
    this.resizeObserver.observe(this);
    document.fonts?.ready.then(this.fit);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  fit() {
    const titles = [...this.querySelectorAll('.fs-cat-card__title')];
    if (!titles.length) return;

    this.style.removeProperty('--fs-cat-title-size');
    this.removeAttribute('data-title-fit');
    this.removeAttribute('data-titles-wrap');

    // La sección permite varios renglones (tipografía personalizada con Pretty/Balance).
    if (this.hasAttribute('data-allow-wrap')) return;

    const baseSize = parseFloat(getComputedStyle(titles[0]).fontSize);
    const ratio = Math.min(
      1,
      ...titles
        .filter((title) => title.scrollWidth > 0)
        .map((title) => title.clientWidth / title.scrollWidth)
    );
    if (ratio >= 1) return;

    // Fraunces ajusta sus proporciones según el tamaño (eje óptico), así que
    // el ancho no escala lineal: se baja 1px a la vez hasta que todo cabe.
    let size = Math.floor(baseSize * ratio);
    this.setAttribute('data-title-fit', '');
    while (size >= FsCategories.MIN_SIZE) {
      this.style.setProperty('--fs-cat-title-size', `${size}px`);
      if (titles.every((title) => title.scrollWidth <= title.clientWidth)) return;
      size -= 1;
    }

    this.style.setProperty('--fs-cat-title-size', `${FsCategories.MIN_SIZE}px`);
    this.setAttribute('data-titles-wrap', '');
  }
}

if (!customElements.get('fs-categories')) {
  customElements.define('fs-categories', FsCategories);
}
